import { getAccessToken } from "../common/authorization/AuthorizeService";

const configuration = {
  isSet: false,
  gatewayUrl: "",
  defaultFetchOptions: {},
  onError: (error) => console.error(error),
};

const fetcher = async (uri, opts, cb, err) => {
  try {
    const authHeader = { Authorization: "Bearer " + (await getAccessToken()) };
    const originHeader = { "Request-Origin": "pisarnica" };
    opts.headers = {
      ...opts.headers,
      ...authHeader,
      ...originHeader,
    };
    // Headers property of opts will not be merged by the Object.assign but rather overriden so we
    // merge it manually
    if (opts.headers && configuration.defaultFetchOptions.headers) {
      opts.headers = {
        ...configuration.defaultFetchOptions.headers,
        ...opts.headers,
        authHeader,
      };
    }

    const response = await fetch(
      /https?:/.test(uri) ? uri : configuration.gatewayUrl + uri,
      Object.assign({ ...configuration.defaultFetchOptions }, opts)
    );
    if (response.ok) {
      let received = await response
        .clone()
        .json()
        .catch(() => response.text());
      if (cb) {
        cb(received);
      } else {
        return received;
      }
    } else {
      if (response.status === 400) {
        let received = await response
          .clone()
          .json()
          .catch(() => response.text());
        if (err) {
          err(received.status + ` TraceId: ${received.traceId}. Molimo Vas probajte kasnije.`);
        } else {
          return received.status;
        }
      } else if (response.status === 403) {
        err("Nemate ovlasti za traženu akciju");
      } else if (response.status === 401) {
        err(response.status + " Molimo Vas probajte kasnije.");
      } else if (response.status === 404 || response.status >= 500) {
        response
          .clone()
          .json()
          .catch(() =>
            response
              .text()
              .then((text) => err(response.status + " - " + text + " Molimo Vas probajte kasnije."))
          );
      }
    }
  } catch (error) {
    if (err) {
      err(error);
    } else {
      configuration.onError(error);
    }
  }
};

const prepareOpts = (method, jsonBody) => {
  let opts = { method };
  opts["body"] = jsonBody ? JSON.stringify(jsonBody) : undefined;
  return opts;
};

const GET = (uri, cb, err, opts = {}) =>
  fetcher(uri, Object.assign(opts, { method: "GET" }), cb, err);

const POST = (
  uri,
  jsonBody,
  cb,
  err,
  opts = {
    headers: {
      "Content-Type": "application/json",
    },
  }
) => fetcher(uri, Object.assign(opts, prepareOpts("POST", jsonBody)), cb, err);

const PUT = (
  uri,
  jsonBody,
  cb,
  err,
  opts = {
    headers: {
      "Content-Type": "application/json",
    },
  }
) => fetcher(uri, Object.assign(opts, prepareOpts("PUT", jsonBody)), cb, err);

const DELETE = (uri, cb, err, opts = {}) =>
  fetcher(uri, Object.assign(opts, { method: "DELETE" }), cb, err);

const configureFetch = (config) => {
  if (!configuration.isSet) {
    Object.assign(configuration, config);
    configuration.isSet = true;
  }
};

export { GET, POST, PUT, DELETE, configureFetch, configuration };
